module.exports = __webpack_public_path__ + "static/media/download.cec0710a.svg";